import type { ScreenKey } from '@shared-core/navigation/routes'
import type { StackMode } from '@shared-core/navigation/screens-list'

export type ScreenRouteKey = Exclude<ScreenKey, StackMode>

// URL-пути экранов для web-роутера (SPA) — общий источник путей.
export const SCREENS_PATHS: Record<ScreenRouteKey, string> = {
  ENTRY_LOADING: 'loading',
  ENTRY_EMAIL: 'email',
  ENTRY_PHONE: 'phone',
  ENTRY_OTP: 'otp',
  HOME_START: 'home',
  TOPUP_AMOUNT: 'topup',
  PAYMENT_LINK: 'payment-link',
  TX_DETAILS: 'tx-details',
  CARD_INFO: 'card',
  CARD_DETAILS: 'card-details',
  CARD_PIN_SETUP: 'card-pin',
  WITHDRAW_BANKS: 'withdraw-banks',
  WITHDRAW_AMOUNT: 'withdraw',
}
